// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"core":"f90d5a6068b365ff2470","SmartGift":"7861c2bf0d4572cf64e0"}[chunkId] + ".bundle.js";
};